__turbopack_context__.v({
  "iframe-wrapper": "_7ol0xq_iframe-wrapper",
  "iframe-wrapper-external": "_7ol0xq_iframe-wrapper-external",
  "play-button": "_7ol0xq_play-button",
  "skeleton-container": "_7ol0xq_skeleton-container",
  "thumbnail-container": "_7ol0xq_thumbnail-container",
  "video-player-embed": "_7ol0xq_video-player-embed",
});
